import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface CopilotStep {
  anchor: string;
  title: string;
  instruction: string;
  action: 'click' | 'type' | string;
  screen: string;
}

export interface CopilotPlanResponse {
  intro: string;
  steps: CopilotStep[];
  model: string;
  anchor_count: number;
}

@Injectable({ providedIn: 'root' })
export class AiCopilotService {
  private readonly BASE = `${environment.chatbotApiUrl}copilot`;

  constructor(private http: HttpClient) {}

  /** Ask the AI to turn a natural-language goal into an ordered, anchored tour. */
  plan(goal: string, sessionId?: string): Observable<CopilotPlanResponse> {
    return this.http.post<CopilotPlanResponse>(`${this.BASE}/plan`, {
      goal,
      session_id: sessionId,
    });
  }
}
